/**
 * Boards of area (g) — saas. OWNED BY area (g) — saas (keep `id`, `href`, `path` stable: the dev navigator,
 * the smoke test and the layout audit read them). Generated by the foundation on 2026-10-15.
 */
import { lazy } from "react";
import type { BoardDef } from "@/boards/types";

export const saasBoards: BoardDef[] = [
  {
    id: "FS-Vue",
    ref: "FS1",
    title: "Facturation SaaS — Vue d'ensemble",
    area: "saas",
    path: "/facturation",
    href: "/facturation",
    permission: ["saas", "read"],
    persona: "admin",
    kind: "page",
    nav: "saas.vue",
    space: "facturation",
    component: lazy(() => import("./boards/FS-Vue")),
  },
  {
    id: "FS-Comptes",
    ref: "FS2",
    title: "Facturation SaaS — Comptes facturation",
    area: "saas",
    path: "/facturation/comptes",
    href: "/facturation/comptes",
    permission: ["saas", "read"],
    persona: "admin",
    kind: "page",
    nav: "saas.comptes",
    space: "facturation",
    component: lazy(() => import("./boards/FS-Comptes")),
  },
  {
    id: "FS-Fiche",
    ref: "FS3",
    title: "Facturation SaaS — Fiche d'un compte",
    area: "saas",
    path: "/facturation/comptes/$companyId",
    href: "/facturation/comptes/cmp_studio_kahn",
    permission: ["saas", "read"],
    persona: "admin",
    kind: "page",
    nav: "saas.comptes",
    space: "facturation",
    component: lazy(() => import("./boards/FS-Fiche")),
  },
  {
    id: "FS-Iopole",
    ref: "FS4",
    title: "Facturation SaaS — Flux facture électronique",
    area: "saas",
    path: "/facturation/flux",
    href: "/facturation/flux",
    permission: ["saas", "read"],
    persona: "admin",
    kind: "page",
    nav: "saas.flux",
    space: "facturation",
    component: lazy(() => import("./boards/FS-Iopole")),
  },
  {
    id: "FS-Incidents",
    ref: "FS5",
    title: "Facturation SaaS — Incidents et support",
    area: "saas",
    path: "/facturation/incidents",
    href: "/facturation/incidents",
    permission: ["saas", "read"],
    persona: "admin",
    kind: "page",
    nav: "saas.incidents",
    space: "facturation",
    component: lazy(() => import("./boards/FS-Incidents")),
  },
  {
    id: "FS-Parametres",
    ref: "FS6",
    title: "Facturation SaaS — Paramètres du produit",
    area: "saas",
    path: "/facturation/parametres",
    href: "/facturation/parametres",
    permission: ["saas", "read"],
    persona: "admin",
    kind: "page",
    nav: "saas.parametres",
    space: "facturation",
    component: lazy(() => import("./boards/FS-Parametres")),
  },
];
